<template>
  <div
    class="coupon-item j-select-coupon-item"
    :pointValue="
      fullReductType ? fullReductMoney + currency : discount + '%OFF'
    "
    v-if="!isEmpty"
    @click="chooseCoupon"
    :class="{ active: active, invalid: invalid }"
  >
    <div class="coupon-item-shade" v-show="active"></div>
    <div class="coupon-item-choose-ico" v-show="active"></div>
    <p class="coupon-item-name" v-if="fullReductType">
      {{ fullReductMoney }}
      <span class="coupon-item-currency">{{ currency }}</span>
    </p>
    <p class="coupon-item-name" v-else>{{ discount }}%OFF</p>
    <p class="coupon-item-tag">{{ tagText }}</p>
    <p class="coupon-item-type" v-if="fullReductLimitBottomMoney === 0">
      {{ letter.couponNoLimit }}
    </p>
    <p class="coupon-item-type" v-if="fullReductLimitBottomMoney > 0">
      {{
        letter.couponFuilCanUse
          .replace('${price}', fullReductLimitBottomMoney)
          .replace('${currency}', currency)
      }}
    </p>
    <p class="coupon-item-date">
      {{ letter.couponInvalidTime }}： {{ localEndDate }}
    </p>
    <p class="coupon-item-line"></p>
    <!-- 2024.12.17 星谕: va活动优惠券特殊显示 -->
    <p
      class="coupon-item-tip"
      v-if="info.COUPON_TYPE === 'EVENT211VA1' && lang == 'ko-KR'"
    >
      【Bank Transfer】결제 방식에서만 사용 가능합니다
    </p>
    <p class="coupon-item-tip" v-else>{{ useLimitTip }}</p>
    <p class="coupon-item-tip">
      {{
        letter.voucherLimitRegion
          ? letter.voucherLimitRegion.replaceAll('${currency}', currency)
          : ''
      }}
    </p>
    <p class="coupon-item-tip" v-if="discountType && discountLimitTopMoney">
      ({{
        letter.couponMaxDiscount
          .replace('${price}', discountLimitTopMoney)
          .replace('${currency}', currency)
      }})
    </p>
    <p class="coupon-item-tip" v-if="hasUsed">
      {{ letter.couponHasUsed }}：{{ localUsedDate }}
    </p>
    <p class="coupon-item-use" v-if="showItemUseBtn">
      <a
        class="coupon-item-use-btn j-click-coupon-item-use"
        :pointValue="
          fullReductType ? fullReductMoney + currency : discount + '%OFF'
        "
        href="javascript:;"
        @click="chooseGameActiveCoupon"
        >{{ letter.couponUseNow }}</a
      >
    </p>
  </div>
  <div class="coupon-item empty" :class="{ invalid: invalid }" v-else>
    <div class="coupon-item-empty-ico"></div>
    <p class="coupon-item-empty-text">{{ letter.couponHasNoCoupon }}</p>
  </div>
</template>

<script type="text/javascript">
import coupon from '@mixins/officialStore/coupon';
import { times } from '../../../utiles/officialStore';
export default {
  name: 'couponItem',
  props: ['info', 'active', 'invalid', 'isEmpty', 'showItemUseBtn'],
  mixins: [coupon],
  computed: {
    fullReductType() {
      return +this.info.TYPE === 0;
    },
    discountType() {
      return +this.info.TYPE === 1;
    },
    startDate() {
      return this.dateFormat(this.info.START_TIME);
    },
    endDate() {
      return this.dateFormat(this.info.EXPIRY_TIME);
    },
    lang() {
      return this.$store.state.lang;
    },
    localStartDate() {
      return this.localFormatTime(this.info.START_TIME);
    },
    localEndDate() {
      return this.localFormatTime(this.info.EXPIRY_TIME);
    },
    localUsedDate() {
      return this.localFormatTime(this.info.USE_TIME);
    },
    currency() {
      return this.info?.CURRENCY || '';
    },
    fullReductLimitBottomMoney() {
      return +this.info.LIMIT_BOTTOM_MONEY || 0;
    },
    fullReductMoney() {
      return this.info.REDUCTION_MONEY || 0;
    },
    discount() {
      return times(+this.info.DISCOUNT, 100);
    },
    discountLimitTopMoney() {
      return +this.info.LIMIT_TOP_MONEY;
    },
    useLimitTip() {
      let tips = [];
      const productType = {
        coin: this.letter.couponOnlyCoinCanUse,
        package: this.letter.couponOnlyPackageCanUse,
        subscription: this.letter.couponOnlySubCanUse,
        currency: this.letter.couponOnlyDaibiCanUse
      };
      const hasPaytypeList =
        (this.info.PAY_TYPE_LIST && this.info.PAY_TYPE_LIST.length) || 0;
      const hasProductList =
        (this.info.PRODUCT_LIST && this.info.PRODUCT_LIST.length) || 0;
      const hasProductType = this.info.PRODUCT_TYPE || 0;

      if (hasProductType) {
        tips.push(productType[this.info.PRODUCT_TYPE]);
      }

      if (hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (hasPaytypeList && !hasProductList) {
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (!hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
      } else if (!hasPaytypeList && !hasProductList && !hasProductType) {
        tips.push(this.letter.couponAllProductCanUse);
      }

      return tips.join(';');
    },
    letter() {
      return this.$store.state.letter;
    },
    tagText() {
      if (this.info.DESCRIPTION) {
        return this.info.DESCRIPTION;
      }
      if (this.fullReductType) {
        return this.letter.couponReductionType;
      }
      if (this.discountType) {
        return this.letter.couponDiscountType;
      }
      return '';
    },
    hasUsed() {
      // -1 提单未支付 0 未使用 1 完成支付 2 回收
      return +this.info.STATE === 1 || +this.info.STATE === -1;
    }
  },
  methods: {
    // timestamp : 时间戳，单位为秒
    localFormatTime(timestamp) {
      return new Date(+timestamp * 1000).toLocaleString(this.lang, {
        hour12: false,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
    },
    dateFormat(time) {
      const t = new Date(+time * 1000);
      const formate = 'Y-M-D h:m';
      let year = t.getFullYear();
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hour = t.getHours();
      let minu = t.getMinutes();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      minu = minu == 0 ? '00' : minu;
      const hash = {
        Y: year,
        M: month,
        D: day,
        h: hour,
        m: minu
      };
      return formate.replace(/\w/g, i => {
        return hash[i];
      });
    },
    chooseGameActiveCoupon() {
      this.updateGameActiveCouponId(this.info.COUPON_ID);
      this.$emit('closePopup');
      ['/vip_score', '/wallet'].includes(this.$route.path) &&
        this.$router.push({ name: 'home' });
    },
    chooseCoupon() {
      this.$emit(
        'chooseCoupon',
        Object.assign({}, this.info, {
          tagText: this.tagText,
          fullReductMoney: this.fullReductMoney
        })
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.coupon-item {
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 10px;
  padding: 29px 32px;
  width: 100%;
  background-size: 100% 100%;
  text-align: left;
  font-size: 24px;
  @psetbg ('coupon-item-valid-bg.png', false, false);
  &-choose-ico {
    position: absolute;
    left: 0;
    top: 0;
    width: 46px;
    height: 46px;
    background: url($pnsImg + 'coupon-item-choose-ico.png') no-repeat;
    /*!rtl:raw:
      background: url('../../../assets/image/officialStore/ztmslg/coupon-item-choose-ico-rtl.png') no-repeat;
    */
  }
  &-name {
    font-size: 54px;
    color: var(--coupon-popup-item-name);
  }
  &-tag {
    margin: 17px 0 14px;
    font-size: 27px;
    color: var(--coupon-popup-item-tag);
  }
  &-type {
    margin: 0 0 14px;
    font-size: 27px;
    color: var(--coupon-popup-item-type);
  }
  &-date {
    color: var(--coupon-popup-item-date);
  }
  &-line {
    margin: 15px auto;
    width: 100%;
    height: 1px;
    background-color: var(--coupon-popup-item-line);
  }
  &-tip {
    margin-bottom: 10px;
    font-size: 20px;
    color: var(--coupon-popup-item-tip);
  }
  &-use {
    display: flex;
    justify-content: end;
    margin: 34px auto 0;
    &-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 36px;
      color: var(--coupon-popup-item-use-btn);
      @psetbg ('coupon-popup-item-use.png');
    }
  }
  &-empty-ico {
    font-size: 0;
    @psetbg ('coupon-popup-item-empty.png');
  }
  &-empty-text {
    margin-top: 30px;
    font-weight: bold;
    font-size: 36px;
    color: var(--coupon-popup-item-empty);
  }
  &-shade {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('coupon-item-shade.png', false, false);
  }
  &.invalid {
    // 这里
    position: relative;
    @psetbg ('coupon-item-invalid-bg.png', false, false);
    .coupon-item-name {
      color: var(--coupon-popup-item-invalid-name);
    }
    .coupon-item-date {
      color: var(--coupon-popup-item-invalid-date);
    }
    .coupon-item-type {
      color: var(--coupon-popup-item-invalid-type);
    }
    .coupon-item-tip {
      color: var(--coupon-popup-item-invalid-tip);
    }
    .coupon-item-line {
      background: var(--coupon-popup-item-invalid-line);
    }
    .coupon-item-tag {
      color: var(--coupon-popup-item-invalid-tag);
    }
    .coupon-item-use {
      display: none;
    }
  }
  &.empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 325px;
    @psetbg ('coupon-item-valid-bg.png', false, false);
    &.invalid {
      .coupon-item-empty-text {
        font-weight: bold;
        font-size: 36px;
        color: var(--coupon-popup-item-empty);
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .coupon-item {
    font-size: 16px;
    &-name {
      font-size: 34px;
    }
    &-type {
      font-size: 16px;
    }
    &-tip {
      font-size: 13px;
    }
    &-use {
      &-btn {
        font-size: 24px;
        @psetbg ('coupon-popup-item-use-hen.png');
      }
    }
    &-tag {
      font-size: 16px;
    }
    &-empty-ico {
      font-size: 0;
      @psetbg ('coupon-popup-item-empty-hen.png');
    }
    &-empty-text {
      font-size: 24px;
    }
    &.empty {
      height: 209px;
      &.invalid {
        .coupon-item-empty-text {
          font-size: 24px;
        }
      }
    }
  }
}
</style>
